import React from "react";

const Container = ({ children }) => {
  return <div className="w-full mx-auto">{children}</div>;
};

export default Container;
